
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '@/hooks/use-admin-auth';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Settings, FileText, Users, BarChart3 } from 'lucide-react';
import { SystemInstructionsEditor } from '@/components/admin/system-instructions-editor';
import { ModelSelector } from '@/components/admin/model-selector';
import { AIParametersEditor } from '@/components/admin/ai-parameters-editor';
import { SemanticSearchConfig } from '@/components/admin/semantic-search-config';
import { DocumentManagement } from '@/components/admin/document-management';
import { UserManagement } from '@/components/admin/user-management';
import AdminDashboard from '@/components/admin/admin-dashboard';

export default function AdminPage() {
  const { isAdmin, loading } = useAdminAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
          <p>Laster admin-panel...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="h-full flex flex-col">
      <div className="border-b bg-background px-6 py-4">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-2xl font-bold">Administrator-panel</h1>
          <p className="text-muted-foreground">
            Administrer systeminstruksjoner, AI-oppførsel, dokumenter og brukerroller
          </p>
        </div>
      </div>

      <div className="flex-1 p-6">
        <div className="max-w-6xl mx-auto">
          <Tabs defaultValue="dashboard" className="space-y-6">
            <TabsList className="grid w-full grid-cols-4">
              <TabsTrigger value="dashboard" className="flex items-center gap-2">
                <BarChart3 className="h-4 w-4" />
                Dashboard
              </TabsTrigger>
              <TabsTrigger value="settings" className="flex items-center gap-2">
                <Settings className="h-4 w-4" />
                Innstillinger
              </TabsTrigger>
              <TabsTrigger value="documents" className="flex items-center gap-2">
                <FileText className="h-4 w-4" />
                Dokumenter
              </TabsTrigger>
              <TabsTrigger value="users" className="flex items-center gap-2">
                <Users className="h-4 w-4" />
                Brukere
              </TabsTrigger>
            </TabsList>

            <TabsContent value="dashboard">
              <AdminDashboard />
            </TabsContent>

            <TabsContent value="settings" className="space-y-6">
              <ModelSelector />
              <AIParametersEditor />
              <SemanticSearchConfig />
              <SystemInstructionsEditor />
            </TabsContent>

            <TabsContent value="documents">
              <DocumentManagement />
            </TabsContent>

            <TabsContent value="users">
              <UserManagement />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
